import { render, staticRenderFns } from "./OtsPage.vue?vue&type=template&id=e3bc0162&"
import script from "./OtsPage.vue?vue&type=script&lang=ts&"
export * from "./OtsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3bc0162')) {
      api.createRecord('e3bc0162', component.options)
    } else {
      api.reload('e3bc0162', component.options)
    }
    module.hot.accept("./OtsPage.vue?vue&type=template&id=e3bc0162&", function () {
      api.rerender('e3bc0162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/Details/OtsPage.vue"
export default component.exports